import React from 'react'
import PropTypes from 'prop-types'

import RelatedProduct from './RelatedProduct';
import RelatedProductCategory from './RelatedProductCategory';
import LoadingSpinner from '../../shared/LoadingSpinner';

class RelatedProductsWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.attributesNamesToMatch = ['Brands', 'Species', 'Doorstyle', 'Cabinet Door Shape', 'Cabinet Finish'];
    this.relatedProductTypes = [
      {
        Name: "Samples",
        ImageName: "Cabinets_Samples"
      },
      {
        Name: "Base Cabinets",
        ImageName: "Cabinets_Base"
      },
      {
        Name: "Wall Cabinets",
        ImageName: "Cabinets_Wall"
      },
      {
        Name: "Panels, Fillers & Moldings",
        ImageName: "Cabinets_Panels"
      },
      {
        Name: "Tall Cabinets",
        ImageName: "Cabinets_Tall"
      },
      {
        Name: "Vanity Cabinets",
        ImageName: "Cabinets_Vanities"
      }
    ]

    this.state = {
      selectedCategoryName: null,
      relatedProducts: [],
      currentPage: 1,
      totalPages: 0,
      hasRelatedProducts: null,
      isLoading: true
    };

    this.initialState = this.state;

    this.getAttributesToMatch = this.getAttributesToMatch.bind(this);
    this.updateSelectedRelatedProductCategory = this.updateSelectedRelatedProductCategory.bind(this);
    this.loadMoreRelatedProducts = this.loadMoreRelatedProducts.bind(this);
    this.checkForRelatedProducts = this.checkForAnyRelatedProducts.bind(this);
    this.renderNoRelatedProducts = this.renderNoRelatedProducts.bind(this);

    this.checkForAnyRelatedProducts();
  }

  async loadRelatedProductsOfType(categoryId, attributesToMatch, categoryAttributesToMatch, currentPage, pageSize) {
    this.setState((prevState) => ({...prevState, isLoading: true}))

    const defaultPageSize = 25;
    pageSize = typeof pageSize !== 'undefined' ? pageSize : defaultPageSize;

    let response = await fetch('/Product/RelatedProducts', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        categoryContentLinkId: categoryId,
        attributesToMatch,
        categoryAttributesToMatch,
        currentPage,
        pageSize
      })
    });

    try {
      let relatedProductResult = await(response).json();

      return relatedProductResult;
    }
    catch(exception) {
      return {
        "products": [],
        "currentPage": 1,
        "totalPages": 1,
        "totalCount": 0
      };
    }
  }

  getAttributesToMatch() {
    let attributesToMatch = this.attributesNamesToMatch.map(attributeNameToMatch => {
      var filter = {
        Name: attributeNameToMatch
      };

      var attribute = this.props.currentVariation.VariationAttributes.find(productAttribute => productAttribute.AttributeName === attributeNameToMatch);
      if (typeof attribute !== 'undefined' && attribute !== null) {
        filter.Value = attribute.AttributeValueName;
      }

      return filter;
    });

    if (this.props.filterForReicoExpress) {
      attributesToMatch.push({
        Name: 'ReicoExpress',
        Value: 'Yes'
      });
    }

    return attributesToMatch;
  }

  getCategoriesToMatch(category) {
    return [
      {
        Name: 'Category 1', 
        Value: category.Name
      },
      {
        Name: 'Category 2', 
        Value: category.Name
      }
    ];
  }

  updateSelectedRelatedProductCategory(categoryName) {
    const category = this.relatedProductTypes.find(relatedType => relatedType.Name === categoryName);
    if (typeof category === 'undefined') {
      this.setState(this.initialState);
      return;
    }
    const categoriesToMatch = this.getCategoriesToMatch(category);
    const attributesToMatch = this.getAttributesToMatch();

    this
      .loadRelatedProductsOfType(this.props.categoryId, attributesToMatch, categoriesToMatch, 1)
      .then((relatedProductResult) => {
        this.setState({
          selectedCategoryName: category.Name,
          relatedProducts: relatedProductResult.products,
          currentPage: relatedProductResult.currentPage,
          totalPages: relatedProductResult.totalPages,
          isLoading: false
        });
      });
  }

  loadMoreRelatedProducts(page) {
    const category = this.relatedProductTypes.find(relatedType => relatedType.Name === this.state.selectedCategoryName);
    const categoriesToMatch = this.getCategoriesToMatch(category);
    const attributesToMatch = this.getAttributesToMatch();

    this
      .loadRelatedProductsOfType(this.props.categoryId, attributesToMatch, categoriesToMatch, page)
      .then((relatedProductResult) => {
        this.setState(state => ({
          relatedProducts: state.relatedProducts.concat(relatedProductResult.products),
          currentPage: relatedProductResult.currentPage,
          totalPages: relatedProductResult.totalPages,
          isLoading: false
        }));
      });
  }

  checkForAnyRelatedProducts() {
    this.setState((prevState) => ({...prevState, isLoading: true}))

    const attributesToMatch = this.getAttributesToMatch();
    const categoriesToMatch = [];
    this.relatedProductTypes.map(category => Array.prototype.push.apply(categoriesToMatch, this.getCategoriesToMatch(category)));

    this
      .loadRelatedProductsOfType(this.props.categoryId, attributesToMatch, categoriesToMatch, 1, 0)
      .then((relatedProductResult) => {
        this.setState({
          hasRelatedProducts: relatedProductResult.totalCount > 0,
          isLoading: false
        });
      });
  }

  renderNoRelatedProducts() {
    const anyRelatedProducts = this.state.hasRelatedProducts;
    const { phoneNumber, phoneText } = this.props.siteInfo;

    return (
      <div className='col-xs-12 text-center'>
        <div className={ anyRelatedProducts ? 'related-product' : 'no-related-product-message' }>
          {anyRelatedProducts
            ? (
                <h4>
                  <p>Sorry, we don’t stock any products in this category for the door style you’ve selected.</p>
                  <p>Contact your Reico representative at <a href={"tel:" + phoneNumber}>{phoneText.trim()}</a> to discuss other available options.</p>
                </h4>
              )
            : (
                <h4>
                  <p>The Door Style you selected is available through special order.</p>
                  <p>Contact Reico at <a href={"tel:" + phoneNumber}>{phoneText.trim()}</a> to discuss custom cabinet options and costs.</p>
                </h4>
              )
          }
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentVariation.Code !== prevProps.currentVariation.Code) {
      this.setState(this.initialState);
      this.checkForAnyRelatedProducts();
    }

    // Re-run the Related Products search if the Reico Express Filter has changed (and a category was selected)
    if (this.props.filterForReicoExpress !== prevProps.filterForReicoExpress && this.state.selectedCategoryName !== null) {
      this.updateSelectedRelatedProductCategory(this.state.selectedCategoryName);
    }
  }
  
  render() {
    // If the state is indeterminate (e.g. hasRelatedProducts is null or undefined), hide the section
    // TODO: We could probably use a spinner here?
    if (this.state.isLoading) {
      return <LoadingSpinner />;
    }

    const relatedProducts = this.state.relatedProducts;
    const categorySelected = typeof this.state.selectedCategoryName !== 'undefined' && this.state.selectedCategoryName !== null;
    const categoryHasRelatedProducts = typeof relatedProducts !== 'undefined' && relatedProducts.length > 0;
    const showLoadMore = this.state.totalPages > 0 && this.state.currentPage < this.state.totalPages;
    const headerText = `${this.state.hasRelatedProducts ? 'Find & Select Cabinets' : 'Contact Reico'} for Your Door Style / Color Selection:`;

    return (
      <div className='related-items'>
        <div className='container-fluid'>
          <div className='related-items-header'>
            <h1 className='text-center'>{headerText}</h1>
          </div>
        </div>
        <div className='container'>
          {
            this.state.hasRelatedProducts 
            ? (
              <div className='row'>
                <div className='related-items-types'>
                    {this.relatedProductTypes.map((relatedProductType) =>
                      <RelatedProductCategory
                        key={relatedProductType.Name}
                        updateSelectedRelatedProductType={this.updateSelectedRelatedProductCategory}
                        productTypeName={relatedProductType.Name}
                        imageName={relatedProductType.ImageName}
                        isSelected={this.state.selectedCategoryName === relatedProductType.Name}
                      />
                    )}
                  </div>
                <div className='related-items-list'>
                    {(categoryHasRelatedProducts)
                      ? (relatedProducts.map((product) => 
                        <RelatedProduct
                          key={product.HitId}
                          product={product}
                          addToCartEndpoint={this.props.addToCartEndpoint}
                          customerType={this.props.customerType}
                          siteName={this.props.siteName}
                          wishlistModel={this.props.wishlistModel}
                          updateWishlists={this.props.updateWishlists}
                        />
                      ))
                      : (categorySelected)
                        ? this.renderNoRelatedProducts()
                        : null
                    }
                    {showLoadMore && 
                      <div className='col-xs-12'>
                        <button type="button" className="btn btn-default load-more-button" onClick={() => this.loadMoreRelatedProducts(this.state.currentPage + 1)}>
                          Load More
                        </button>
                      </div>
                    }
                </div>
              </div>
            )
            : this.renderNoRelatedProducts()
          }
        </div>
      </div>
    );    
  }

}

RelatedProductsWrapper.propTypes = {
  addToCartEndpoint: PropTypes.string,
  categoryId: PropTypes.number,
  currentVariation: PropTypes.object,
  filterForReicoExpress: PropTypes.bool,
  siteInfo: PropTypes.shape({
    siteName: PropTypes.string,
    phoneNumber: PropTypes.string,
    phoneText: PropTypes.string
  }),
  isLoading: PropTypes.bool,
  customerType: PropTypes.string,
  siteName: PropTypes.string,
  wishlistModel: PropTypes.object
}

export default RelatedProductsWrapper